"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _loadPopulations = require("../actions/campaignCreator/populations/loadPopulations");

var _setUniverse = require("../actions/campaignCreator/universes/setUniverse");

var _loadUniverses = require("../actions/campaignCreator/universes/loadUniverses");

var _totalPopulationHook = require("../helpers/totalPopulationHook");

var _useFeatureAccessHook = require("../helpers/useFeatureAccessHook");

var _StateFilter = _interopRequireDefault(require("../components/StateFilter"));

var _AudienceViewToggle = _interopRequireDefault(require("../components/Data/AudienceViewToggle"));

var _DataLinks = _interopRequireDefault(require("../components/Data/DataLinks"));

var _DownloadCSVButton = require("../components/DownloadCSVButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function WorkflowStateFilter(_ref) {
  var fixedAudienceView = _ref.fixedAudienceView,
      location = _ref.location,
      _ref$displayStateFilt = _ref.displayStateFilter,
      displayStateFilter = _ref$displayStateFilt === void 0 ? true : _ref$displayStateFilt,
      currentDataPage = _ref.currentDataPage;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isDataPage = (0, _reactRedux.useSelector)(function (state) {
    return state.options.isDataPage.value;
  });
  var selectedPersonas = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedPersonas.personas;
  });
  var population = (0, _reactRedux.useSelector)(function (state) {
    return state.population.results;
  });
  var selectedPersonasLength = selectedPersonas.length;

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.audienceView.view;
  }),
      audienceView = _useSelector.value,
      segmentType = _useSelector.segmentType;

  var isCommunity;

  if (fixedAudienceView) {
    isCommunity = fixedAudienceView === 'communities' && isDataPage;
  } else {
    isCommunity = audienceView === 'communities' && isDataPage;
  }

  var filteredPopulation = (0, _totalPopulationHook.useTotalPopulation)(selectedPersonas, population, isCommunity);
  var loadingPop = (0, _reactRedux.useSelector)(function (state) {
    return state.population.isFetching;
  });

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state.universes;
  }),
      universes = _useSelector2.results,
      currentUniverse = _useSelector2.currentUniverse,
      isFetching = _useSelector2.isFetching;

  var stateFilterPermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.stateFilter;
  });
  var hasDataFiltering = (0, _useFeatureAccessHook.useFeatureAccess)(stateFilterPermission);
  (0, _react.useEffect)(function () {
    dispatch((0, _loadPopulations.loadPopulations)());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    dispatch((0, _loadUniverses.loadUniverses)());
  }, [dispatch]);

  var changeTheUniverse = function changeTheUniverse(universeId) {
    dispatch((0, _setUniverse.setUniverse)(universeId));
  };

  return /*#__PURE__*/_react["default"].createElement(_StateFilter["default"], {
    selectedPersonasLength: selectedPersonasLength,
    loadingPop: loadingPop,
    population: filteredPopulation,
    hasDataFiltering: hasDataFiltering,
    universes: universes,
    currentUniverse: currentUniverse,
    setUniverse: changeTheUniverse,
    isFetching: isFetching,
    audienceView: audienceView,
    isDataPage: isDataPage,
    fixedAudienceView: fixedAudienceView,
    displayStateFilter: displayStateFilter
  }, isDataPage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DownloadCSVButton.DownloadCSVButton, {
    currentDataPage: currentDataPage
  }), /*#__PURE__*/_react["default"].createElement(_DataLinks["default"], {
    selectedPersonas: selectedPersonas,
    segmentType: segmentType,
    currentUniverse: currentUniverse,
    currentDataPage: currentDataPage
  })), isDataPage && !fixedAudienceView && /*#__PURE__*/_react["default"].createElement(_AudienceViewToggle["default"], null));
}

var _default = WorkflowStateFilter;
exports["default"] = _default;